import React, { FC } from 'react';
import { FormInput } from '../../merchants/FormInput';
import { SectionWrapper } from '../../SectionWrapper';
import { useTranslation } from 'react-i18next';
import {
  COMPANY_INFO_INPUTS_FIRST_ROW, COMPANY_INFO_INPUTS_SECOND_ROW
} from '../../../constants/new-application/quick-application/account-information-inputs';
import { useParams } from 'react-router-dom';
import { checkIfValidUUID } from '../../../layout/core';
import clsx from 'clsx';

interface Props {
  formik: any;
}

export const CompanyInformation: FC<Props> = (props) => {
  const { t } = useTranslation();
  const { formik } = props;
  const { id } = useParams<{ id: string }>();
  const applicationId = checkIfValidUUID(id) ? id : undefined;

  const INPUTS_FIRST_ROW = COMPANY_INFO_INPUTS_FIRST_ROW({ t, applicationId });
  const INPUTS_SECOND_ROW = COMPANY_INFO_INPUTS_SECOND_ROW({ t, applicationId });

  return (
      <SectionWrapper
          title={t('NEW_APPLICATION.COMPANY_INFORMATION')}
          pageLoading={false}
          isCardBody
          sectionAdditionalClass="mb-10"
      >
        <div className="row">
          {
            INPUTS_FIRST_ROW.map(item => {
              return (
                  <FormInput
                      {...item}
                      formik={formik}
                      isEditMode={true}
                      key={item.key}
                  />
              );
            })
          }
        </div>
        <div className="row">
          {
            INPUTS_SECOND_ROW.map(item => {
              return (
                  <FormInput
                      {...item}
                      formik={formik}
                      isEditMode={true}
                      key={item.key}
                  />
              );
            })
          }
        </div>
      </SectionWrapper>
  );
};
